import { render, staticRenderFns } from "./EmrDashboardPage.vue?vue&type=template&id=ac341480&scoped=true"
import script from "./EmrDashboardPage.vue?vue&type=script&lang=js"
export * from "./EmrDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./EmrDashboardPage.vue?vue&type=style&index=0&id=ac341480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac341480",
  null
  
)

export default component.exports